"use strict";
/**
 * @file 城市控件
 * @author hedongran
 * @email hdr01@126.com
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Control_1 = tslib_1.__importDefault(require("./Control"));
/**
 * 城市控件，默认位于地图左上角
 * @visibleName CityListControl 城市选择控件
 */
var CityListControl = /** @class */ (function (_super) {
    tslib_1.__extends(CityListControl, _super);
    function CityListControl(props) {
        return _super.call(this, props) || this;
    }
    CityListControl.prototype.getControl = function () {
        return new BMapGL.CityListControl(this.getOptions());
    };
    CityListControl.prototype.render = function () {
        return null;
    };
    return CityListControl;
}(Control_1.default));
exports.default = CityListControl;
